import PasswordValidator from 'password-validator';

const passwordValidation = (password) => {
  const schema = new PasswordValidator();

  schema
    .is().min(8)
    .is().max(50)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .digits()
    .has()
    .not()
    .spaces();

  return schema.validate(password, { list: true });
};

export default passwordValidation;
